import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from './card.component';
import { AngularMaterialModule } from '@morningstar/shared/ui-kit/angular-material'
import { FlexModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    CardComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexModule
  ],
  exports: [
    CardComponent
  ]
})
export class CardModule { }
